<article class="page-container flex flex-column">
  <!-- <section class="align-self-end">
    <button pButton icon="fas fa-file-download" iconPos="right" class="p-button-success p-button-outlined"
      [pTooltip]="screen.actions.download" (click)="downloadTemplate()" [label]="screen.labels.template"></button>
  </section> -->

  <section class="inline-flex">
    <p-table #dt [value]="cie.content" [lazy]="true" (onLazyLoad)="lazyReadCie($event)" [paginator]="true"
      [rows]="pageSize" [totalRecords]="cie.totalElements" [loading]="loading" dataKey="id" class="col-12 p-0"
      tableStyleClass="col-12">
      <ng-template pTemplate="header">
        <tr>
          <th [attr.rowspan]="2" [style.width.px]="45"></th>
          <th [attr.rowspan]="2" [style.width.px]="200">{{screen.labels.publishYear}}</th>
          <th [attr.rowspan]="2" [style.width.px]="150">{{screen.labels.code}}</th>
          <th>{{screen.labels.description}}</th>
        </tr>
        <tr>
          <th>
            <input pInputText type="text" name="dtDescription" [(ngModel)]="dtDescription"
              (input)="dt.filter(dtDescription, 'document', 'contains')">
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-cie let-expanded="expanded">
        <tr>
          <td class="text-center">
            <a href="#" [pRowToggler]="cie">
              <i class="text-info fas" [ngClass]="{'fa-chevron-down': expanded, 'fa-chevron-right': !expanded}"></i>
            </a>
          </td>
          <td>{{cie.publishYear}}</td>
          <td>{{cie.id}}</td>
          <td class="text-ellipsis">{{cie.displayName}}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="rowexpansion" let-cie>
        <tr>
          <td colspan="4">
            <div class="flex">
              <span class="ui-g-8 ui-g-offset-2">{{cie.description}}</span>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </section>

  <section class="align-self-end">
    <ms-table-paged-footer [page]="cie"></ms-table-paged-footer>
  </section>
</article>